import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancelEmailButtonLabel: {
    id: "component.entityEmails.cancelEmailButtonLabel",
    defaultMessage: "Cancel",
    description: "Entity emails cancel email button label",
  },
  companyEmailsCantBeSynced: {
    id: "component.entityEmails.companyEmailsCantBeSynced",
    defaultMessage: "Add a domain or email address to this record to sync emails.",
    description: "Company emails can't be synced message",
  },
  createEmailActivityLabel: {
    id: "component.entityEmails.createEmailActivityLabel",
    defaultMessage: "Create email activity after send",
    description: "Entity emails create email activity label",
  },
  dateFormatDay: {
    id: "component.entityEmails.dateFormatDay",
    defaultMessage: "MMM d",
    description: "Entity emails day date format",
  },
  dateFormatFull: {
    id: "component.entityEmails.dateFormatFull",
    defaultMessage: "EEE MMM d, p",
    description: "Entity emails full date format",
  },
  downloadAttachment: {
    id: "component.entityEmails.downloadAttachment",
    defaultMessage: "Download",
    description: "Entity emails download attachment",
  },
  emailInfoBcc: {
    id: "component.entityEmails.emailInfoBcc",
    defaultMessage: "Bcc",
    description: "Entity emails email info bcc",
  },
  emailInfoCc: {
    id: "component.entityEmails.emailInfoCc",
    defaultMessage: "Cc",
    description: "Entity emails email info cc",
  },
  emailInfoDate: {
    id: "component.entityEmails.emailInfoDate",
    defaultMessage: "Date",
    description: "Entity emails email info date",
  },
  emailInfoDateFormat: {
    id: "component.entityEmails.emailInfoDateFormat",
    defaultMessage: "EEE, MMM d, yyyy 'at' p",
    description: "Entity emails email info date format",
  },
  emailInfoFrom: {
    id: "component.entityEmails.emailInfoFrom",
    defaultMessage: "From",
    description: "Entity emails email info from",
  },
  emailInfoTo: {
    id: "component.entityEmails.emailInfoTo",
    defaultMessage: "To",
    description: "Entity emails email info to",
  },
  emailIsNotFilled: {
    id: "email.creationModal.replyEmailIsNotFilled",
    defaultMessage: "Fill out body to continue",
    description: "Reply email is not filled",
  },
  emailSentSuccessNotificationMessage: {
    id: "component.entityEmails.emailSentSuccessNotificationMessage",
    defaultMessage: "Email sent successfully",
    description: "Entity emails sent success notification message",
  },
  emailsNotFoundMessage: {
    id: "component.entityEmails.emailsNotFoundMessage",
    defaultMessage: "No emails found.",
    description: "Entity emails not found message",
  },
  emailToPrefix: {
    id: "component.entityEmails.emailToPrefix",
    defaultMessage: "To",
    description: "Entity emails email to prefix",
  },
  inboxFolderLabel: {
    id: "component.entityEmails.inboxFolderLabel",
    defaultMessage: "Inbox",
    description: "Entity emails inbox folder label",
  },
  meRecipient: {
    id: "component.entityEmails.meRecipient",
    defaultMessage: "me",
    description: "Entity emails me recipient",
  },
  personEmailsCantBeSyncedMessage: {
    id: "component.entityEmails.personEmailsCantBeSyncedMessage",
    defaultMessage: "Add an email address to this record to sync emails.",
    description: "Person emails can't be synced message",
  },
  replyAllTooltip: {
    id: "component.entityEmails.replyAllTooltip",
    defaultMessage: "reply all",
    description: "Entity emails email reply all tooltip",
  },
  replyTooltip: {
    id: "component.entityEmails.replyTooltip",
    defaultMessage: "reply",
    description: "Entity emails email reply tooltip",
  },
  searchTextPlaceholder: {
    id: "component.entityEmails.searchTextPlaceholder",
    defaultMessage: "Search emails",
    description: "Entity search text placeholder",
  },
  sendEmailButtonLabel: {
    id: "component.entityEmails.sendEmailButtonLabel",
    defaultMessage: "Send",
    description: "Entity emails send email button label",
  },
  sentFolderLabel: {
    id: "component.entityEmails.sentFolderLabel",
    defaultMessage: "Sent",
    description: "Entity emails sent folder label",
  },
  syncEmailButtonLabel: {
    id: "component.entityEmails.syncEmailButtonLabel",
    defaultMessage: "Sync my email",
    description: "Entity emails sync email button label",
  },
  syncEmailMessage: {
    id: "component.entityEmails.syncEmailMessage",
    defaultMessage: "Please sync your email to see emails associated with this record.",
    description: "Entity emails sync email message",
  },
  syncFailedAlertMessage: {
    id: "component.entityEmails.syncFailedAlertMessage",
    defaultMessage: "An error has occurred while syncing. Please contact support.",
    description: "Entity emails sync failed message",
  },
  syncInProgressAlertMessage: {
    id: "component.entityEmails.syncInProgressAlertMessage",
    defaultMessage: "Syncing in progress...",
    description: "Entity emails sync in progress message",
  },
});

export default messages;
